import { Amplify } from 'aws-amplify';
import { signOut } from 'aws-amplify/auth';

const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL;
const userPoolClientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;

if (!userPoolId || !userPoolClientId) {
  // eslint-disable-next-line no-console
  console.error(
    'Amplify Auth: REACT_APP_COGNITO_USER_POOL and REACT_APP_COGNITO_CLIENT_ID must be set. Add them to .env.local and restart the dev server.',
  );
}

function getOAuthRedirects() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return {
      redirectSignIn: [`${window.location.origin}/oauth-login`],
      redirectSignOut: [`${window.location.origin}/oauth-logout`],
    };
  }
  const signIn = (process.env.REACT_APP_OAUTH_REDIRECT_SIGN_IN || 'http://localhost:3004/oauth-login')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
  const signOut = (process.env.REACT_APP_OAUTH_REDIRECT_SIGN_OUT || 'http://localhost:3004/oauth-logout')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
  return { redirectSignIn: signIn, redirectSignOut: signOut };
}

function getAuthConfig() {
  const redirects = getOAuthRedirects();
  const authConfig = {
    Auth: {
      Cognito: {
        userPoolId: userPoolId || '',
        userPoolClientId: userPoolClientId || '',
        ...(cognitoDomain && {
          loginWith: {
            oauth: {
              domain: cognitoDomain.replace(/^https?:\/\//, '').replace(/\/$/, ''),
              scopes: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
              redirectSignIn: redirects.redirectSignIn,
              redirectSignOut: redirects.redirectSignOut,
              responseType: 'code',
            },
          },
        }),
      },
    },
  };
  return authConfig;
}

Amplify.configure(getAuthConfig());

export function reapplyAmplifyOAuthConfig() {
  Amplify.configure(getAuthConfig());
}

export function getCognitoLogoutUrl() {
  const domain = cognitoDomain?.replace(/^https?:\/\//, '').replace(/\/$/, '');
  const signOutRedirect =
    typeof window !== 'undefined' && window.location?.origin
      ? `${window.location.origin}/oauth-logout`
      : (process.env.REACT_APP_OAUTH_REDIRECT_SIGN_OUT || 'http://localhost:3004/oauth-logout')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)[0];
  if (!domain || !userPoolClientId || !signOutRedirect) return null;
  return `https://${domain}/logout?client_id=${encodeURIComponent(userPoolClientId)}&logout_uri=${encodeURIComponent(signOutRedirect)}`;
}
export async function oauthLogout() {
  const logoutUrl = getCognitoLogoutUrl();
  if (!logoutUrl) {
    await signOut();
    return;
  }
  try {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: userPoolId || '',
          userPoolClientId: userPoolClientId || '',
        },
      },
    });
    await signOut();
  } finally {
    reapplyAmplifyOAuthConfig();
  }
  window.location.href = logoutUrl;
}
